module.exports = __webpack_public_path__ + "static/icons_startseite_sonstiges-e730a4a9166007125352d509c66c05c0.png";